
const digest = '187d43e1b341a495fd4f2d733547914f0e356db7b9d6349903c5457c12ca1e4a';
const classes = {"wrapper":"_wrapper_5ac2v_1","codeWrapper":"_codeWrapper_5ac2v_6","buttonWrapper":"_buttonWrapper_5ac2v_11"};
const css = `._wrapper_5ac2v_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_5ac2v_1 ._codeWrapper_5ac2v_6 {
  display: flex;
  gap: 8px;
  align-items: center;
}
._wrapper_5ac2v_1 ._buttonWrapper_5ac2v_11 {
  display: flex;
  flex-direction: column;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  